import AjaxBuilder from '../../../../Common/AjaxBuilder';
import { Station } from "./Station";

export class StationFrom extends Station {
    constructor({ searchModule, lang, loader, changeDatepickerHandler }) {
        super({ module: searchModule, lang, changeDatepickerHandler: changeDatepickerHandler });

        this._loader = loader;

        this.$inputElement = $(this.$searchModule).find('#departureCity');

        this.$locationWrapper = $(this.$inputElement).closest('.widget_input__from').find('.widget_locations');

        this._cities = [];
        this._popularCities = [
            {
                id: 2200000,
                value: this.lang === 'ru-ua' ? 'Киев' : 'Київ',
                railroad: this.lang === 'ru-ua' ? 'Юго-Западная Ж.д.' : 'Південно-Західна Ж.д.',
            },
            {
                id: 2208000,
                value: this.lang === 'ru-ua' ?  'Одесса' : 'Одеса',
                railroad: this.lang === 'ru-ua' ? 'Юго-Западная Ж.д.' : 'Південно-Західна Ж.д.',
            },
            {
                id: 2200600,
                value: this.lang === 'ru-ua' ?  'Чернигов' : 'Чернігів',
                railroad: this.lang === 'ru-ua' ? 'Юго-Западная' : 'Південно-Західна',
            },
            {
                id: 2204000,
                value: this.lang === 'ru-ua' ?  'Харьков' : 'Харків',
                railroad: this.lang === 'ru-ua' ? 'Юго-Западная' : 'Південно-Західна',
            },
            {
                id: 2210707,
                value: this.lang === 'ru-ua' ?  'Днепр' : 'Дніпро',
                railroad: this.lang === 'ru-ua' ? 'Приднепровская' : 'Приднiпровська',
            },
            {
                id: 2210793,
                value: this.lang === 'ru-ua' ?  'Запорожье' : 'Запоріжжя',
                railroad: this.lang === 'ru-ua' ? 'Юго-Западная' : 'Південно-Західна',
            },
            // {
            //     id: 2218000,
            //     value: this.lang === 'ru-ua' ? 'Львов' : 'Львiв',
            //     railroad: this.lang === 'ru-ua' ? 'Львовская Ж.д.' : 'Львівська Ж.д.',
            // },
        ];

        this._selectedCityElement = null;

        this._init();
    }

    _init() {
        this.$inputElement.on('focus', () => {
            $(this.$locationWrapper).addClass('_show');
        });

        this.$inputElement.on('input', this._searchCityHandler.bind(this));
        this.$locationWrapper.on('click', this._cityHandler.bind(this));
    }

    getCities() {
        const selectedCity = this._takeSelectedCity('departure_station');
        const selectedCityName = this._takeSelectedCity('departure_station_name');

        //Если города не выбраны, то предложить популярные
        if (!selectedCity) {
            this._getPopularCities('departure');
            return false;
        } 

        return new Promise(resolve => {
            new AjaxBuilder({
                route: this._searchCityRoute,
                data: {
                    name: selectedCityName.replace('-', ' ').split(' ')[0],
                }
            }, 'GET').execute(
                {
                    success: (data) => {
                        this._cities = data.response.station;
                        this._createCityList();

                        const city = this._cities.find(city => city.id == selectedCity);

                        if (city) {
                            this._selectedCityElement = this.$locationWrapper.find(`li[data-id="${city.id}"]`);
                            this._selectedCityElement.addClass('_selected');
                            this.$inputElement.val(this._selectedCityElement.data('name'));
                            return resolve(data.response.station);
                        }
                    }
                }
            );
        });
    }
}